import { gql } from "@apollo/client";

export const getUndismissedExperiences = gql`
    query getUndismissedExperiences($input: GetUndismissedExperiencesRequest!) {
        getUndismissedExperiences(input: $input) {
            experienceTypes
        }
    }
`;
